<p-toast
  position="top-right"
  [baseZIndex]="2104"
  key="osf"
  [preventOpenDuplicates]="true"
  [breakpoints]="{ '576px': { width: '80%' } }"
>
  <ng-template let-message pTemplate="message">
    <div class="font-medium w-full">{{ message.summary | translate: message.data?.translationParams }}</div>
  </ng-template>
</p-toast>
